import { IGameState } from '../../../../../../src/State/Game/IGameState';
import IPlayerData from 'Player/IPlayerData';
import { AsyncActionStatus } from '../../../../../../src/State/AsyncAction';
import { PopupID } from '../../../../../../src/State/UI/PopupID';
import Game from '../../../../../../src/Game';
import GameStateHelper from '../../../../../../src/State/Game/GameStateHelper';
import UIStateHelper from 'State/UI/UIStateHelper';
import { WorldDataHelper } from 'Utility/WorldDataHelper';
import { completeConflictResolution } from '../../../../../../src/State/Game/DataConflict/DataConflict';
import { trackDataConflictResolution } from 'Utility/Tracking/TrackingHelpers/DataRestore';
import { PlayerDataLocation } from 'Utility/DataConflict/DataConflictsHelper';
import { LoginStateHelper } from 'State/Player/Login/LoginStateHelper';
import { DataConflictRestoreSelection } from 'State/Game/DataConflictRestoreSelection';

export function resolveConflicts(
    state: IGameState,
    result: IPlayerData,
    restoreSelection?: DataConflictRestoreSelection,
    playerDataLocation?: PlayerDataLocation
) {
    // Hide conflict resolution popup
    state = UIStateHelper.hidePopupFullState(state, PopupID.DATA_CONFLICT_POPUP, {});

    state = {
        ...state,
        playerState: Game.player.data.restorePlayerStateFromEndpointData(result),
    };

    state = LoginStateHelper.incrementSessionCount(state);

    // Reload world.

    const playerLevel = Game.player.getHighestLevelCompleted(state);
    const maxWorld = WorldDataHelper.getWorldNumber(playerLevel);

    trackDataConflictResolution(state, result, restoreSelection, playerDataLocation);

    if (state.activeScene.status === AsyncActionStatus.COMPLETE && playerDataLocation !== PlayerDataLocation.DEVICE) {
        state = GameStateHelper.loadWorld(state, {
            worldNumber: maxWorld,
        });
    }

    // Complete conflict resolution
    state = completeConflictResolution(state);

    return state;
}
